import { QUERY_KEYS } from '../../../../consts';
import { getAtomWithMutation } from '../../../../utils';
import { getHtmlSignDocumentService } from '../../../../services/documents/get/get-html-sign-document.service';

export const getHtmlSignDocumentAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.DOCUMENTS.HTML_SIGN_DOCUMENT,
  mutationFn: () => getHtmlSignDocumentService,
});
